import lottie from 'lottie-web'
import GSAP from 'gsap'
/**
 * Logo animation hover
 */
const logo = document.getElementById('logo')
const bulles = document.querySelector('.bulles_message')
const message = bulles.children[0].children[0]

//load lottie animation
let logoAnim = lottie.loadAnimation({
  container: document.getElementById('logo'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: 'logo.json',
})

let messages = {}
messages.message = [`...`, `Ok, stop :/`, `What's up ..? `, 'How are you ?', 'Hello there !']

logo.addEventListener('mouseenter', e => {
  e.preventDefault()
  //logo move
  logoAnim.setDirection(0.8)
  logoAnim.play()

  //play audio
  const hoverAudio = document.querySelector('.pop')
  hoverAudio.muted = false
  hoverAudio.play()
  hoverAudio.volume = 0.2

  //Message appear
  GSAP.to(bulles, { autoAlpha: 1, y: 8, duration: 0.5, ease: 'Bounce.easeOut' })

  //Change text
  messages.current = messages.message.pop()
  message.textContent = messages.current
  e.stopPropagation()
})

logo.addEventListener('mouseleave', e => {
  //logo move back
  logoAnim.setDirection(-1)
  logoAnim.setSpeed(1)
  logoAnim.play()

  //reset messages
  messages.message.unshift(messages.current)
  message.textContent = ''

  GSAP.to(bulles, { autoAlpha: 0, y: 0, duration: 0.2 })
})
